import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { CloseButton, Form, FormGroup } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/question.css";

const DeclarationModal = ({
  isOpen,
  onRequestClose,
  setAgreed,
  agreed,
  className,
  overlayClassName,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Declaration Modal"
      ariaHideApp={false}
      className={className}
      overlayClassName={overlayClassName}
    >
      <div className="d-flex justify-content-between">
        <h4 className="dec-heading">DECLARATION</h4>
        <CloseButton onClick={onRequestClose} />
      </div>
      <div className="declaration">
        <p>
          The individual(s) signing below and any person for which information
          is provided affirmatively consents and agrees: (i) that we hereby
          represent that I/we am/are authorized to provide all information
          submitted and hereby provide my/our written instructions to Mazo
          Capital Solutions and its affiliates, assigns, successors and lending
          partners (collectively "Mazo Capital Solutions") to obtain information
          concerning the applicant and me/us from any company, entity,
          organization, government agency (including law enforcement) or
          business, including my/our consumer and business credit reports),
          employment information, business dealings and trade references; (lil
          that Mazo Capital Solutions may use and share any submitted and
          gathered information from or about the applicant and its owners or
          principals with lenders for consideration for a credit product,
          including any loan or lease or to finance the purchase of equipment;
          (ili) that all information provided is true, accurate and complete;
          (iv) that Mazo Capital Solutions may initially and subsequently obtain
          information from my/our consumer or business credit reports) and
          otherwise in order to: [al confirm my/our identity; b) avoid
          fraudulent transactions in my/our name; (c) to evaluate my/our and any
          applicant's initial and continuing creditworthiness; (d to update,
          renew, confirm, extend, supplement, enforce and collect on any credit
          transaction resulting from this application; and (e) that such
          inquiries may appear on my/our credit reports; (v) we waive any right
          or claim under the Fair Credit Reporting Act, the Drivers' Policy
          Protection Act and the Gramm-Leach-sliley Act arising in the absence
          of this continuing consent; and (vi) to receive any notices required
          by law electronically to the electronic mail addresses) and or mobile
          telephone numbers provided. The Federal Equal Credit Opportunity Act
          prohibits creditors from discriminating against credit applicants on
          the basis of race, color, religion, national origin, sex, marital
          status or age (provided the applicant has the capacity to enter into
          the binding contract); because all or part of the applicant's income
          derives from any public assistance program; or because the applicant
          has in good faith exercised any right under the Consumer Credit
          Protection Act. If for any reason your application for business credit
          is denied, you have the right to a written statement of the specific
          reasons for the denial. To obtain the statement, please write to Mazo
          Capital Solutions, 300 Spectrum Center Drive, Suite 1070, Irvine, CA
          92618 within 60 days from the date you are notified of our decision.
          We will send you a written statement of reasons for the denial of
          credit within 30 days of receiving your request for the statement. If
          you have provided Mazo Capital Solutions with a mobile telephone
          number, above or otherwise, you expressly consent to receive SM5 text
          messages related to your application, any resulting transaction as
          well as promotional and marketing messages. You may opt out at any
          time by responding to any message we send with STOP, UNSUBSCRIBE,
          CANCEL, END or QUIT, after which we may send you a message confirming
          you have opted out. You may opt in again by replying to any previous
          message with START
        </p>
        <Form>
          <FormGroup>
            <FormControlLabel
              className="agree"
              control={
                <Checkbox
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                />
              }
              label={
                <>
                  I agree to Credit Authorization{" "}
                  <span className="text-danger">*</span>
                </>
              }
            />
          </FormGroup>
        </Form>
      </div>
    </Modal>
  );
};

export default DeclarationModal;
